import React, { useState } from "react"

const ServiceFaq: React.FC = () => {
    const [active, setActive] = useState<number>(1);

    const toggle = (id: number) => setActive(active === id ? -1 : id);

    const steps = [
        {
            id: 1,
            title: "01. API Request",
            content:
                "Send a request to the TrustEngine endpoint with a selfie and document photo (KTP/Passport). All data is encrypted end-to-end using TLS 1.3 before processing.",
        },
        {
            id: 2,
            title: "02. Document OCR & Extraction",
            content:
                "Our OCR engine extracts data from the document — name, NIK, date of birth, address — with >99% accuracy in milliseconds. Supports KTP, SIM, Passport, and NPWP.",
        },
        {
            id: 3,
            title: "03. Biometric Verification",
            content:
                "Our AI model compares the selfie against the document photo using 99.8% accuracy face matching, with liveness detection to prevent spoofing and deepfake attacks.",
        },
        {
            id: 4,
            title: "04. Risk & Compliance Check",
            content:
                "Every identity is screened against PPATK watchlist databases, international sanctions, and PEP lists in real-time. A risk score is returned alongside the verification decision.",
        },
    ];

    return (
        <div className="service-process-wrap pt-120 pb-125">
            <div className="row mt-none-50 align-items-center">
                <div className="col-lg-6 mt-50">
                    <h2 className="details-content-title mb-40">How It Works</h2>
                    <div className="service_process_faq">
                        <div className="accordion">
                            {steps.map((item) => (
                                <div className="accordion-item" key={item.id}>
                                    <div
                                        className={`accordion-button ${active === item.id ? "" : "collapsed"}`}
                                        role="button"
                                        onClick={() => toggle(item.id)}
                                    >
                                        {item.title}
                                    </div>
                                    <div className={`accordion-collapse collapse ${active === item.id ? "show" : ""}`}>
                                        <div className="accordion-body">
                                            <p className="m-0">{item.content}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 mt-50">
                    <ul className="content_layer_group list-unstyled">
                        {steps.map((item) => (
                            <li
                                key={item.id}
                                onClick={() => toggle(item.id)}
                                className={active === item.id ? "active" : ""}
                            >
                                <span>{item.title.replace(/^\d+\.\s/, "")}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ServiceFaq;
